import React, { useEffect, useRef, useState } from "react";
import { Icon } from "@anchor/react-components/dist/lib/components";
import { McTooltip, McIcon } from "@maersk-global/mds-react-wrapper/components-core";
import RecovModal from "./RecovModal";
import UserInfo from "../../../context/UserAccessContext";
import { IsLocked } from "../../IsLocked/IsLocked";

// Check if content meets minimum length (50 chars for meaningful content)
const hasMinimumContent = (html, minChars = 50) => {
  if (!html) return false;
  const text = html.replace(/<[^>]*>/g, "").trim();
  return text.length >= minChars;
};

function Recovery(props) {
  const [recovery, setRecovery] = useState({
    recovery: props.RecoveryState.recovery || "",
    changedFields: props.changedFields,
  });
  const { graphData } = UserInfo();

  const [recovModal, setRecovModal] = useState(false);
  const savingRef = useRef(false);

  const handleRecovModal = () => {
    setRecovModal(!recovModal);
    props.setModalIsOpen((current) => {
      return {
        ...current,
        recovery: !current.recovery,
      };
    });
  };

  const onSave = () => {
    savingRef.current = true;
    props.dispatch({
      type: "HANDLE EDITOR CHANGE",
      field: "RecoveryState",
      payload: { recovery: recovery.recovery },
    });
    props.dispatch({
      type: "HANDLE EDITOR CHANGE",
      field: "changedFileds",
      payload: (prev) => ({ ...prev, recovery: true }),
    });
    handleRecovModal();
    if (props.onAutoSave) {
      setTimeout(() => { props.onAutoSave(); savingRef.current = false; }, 100);
    } else {
      savingRef.current = false;
    }
  };

  useEffect(() => {
    setRecovery({
      recovery: props.RecoveryState.recovery || "",
      changedFields: props.changedFields,
    });
  }, [props?.RecoveryState?.recovery]);

  const handleRecoveryChange = (value) => {
    setRecovery(() => {
      return {
        recovery: value,
        changedFields: {
          ...recovery.changedFields,
          recovery: true,
        },
      };
    });
  };

  return (
    <>
      <div id="section-recovery" className="sre-section-card recovery-description-div-tour-step">
        {/* Header */}
        <div className="sre-section-header">
          <span className="sre-section-header-title">Recovery</span>
          {hasMinimumContent(props.RecoveryState?.recovery) ? (
            <span className="sre-section-complete-badge">✓ Complete</span>
          ) : (
            <span className="sre-section-warning-badge">Incomplete</span>
          )}
          <McTooltip position="bottom-right" fit="small" width={320}>
            <McIcon slot="trigger" icon="info-circle" size="16" style={{ cursor: "pointer", color: "#fff" }} />
            <div style={{ fontSize: "12px", lineHeight: "1.6", padding: "4px 0" }}>
              <strong>SRE Best Practices — Recovery</strong>
              <ul style={{ margin: "6px 0 0", paddingLeft: "16px" }}>
                <li>List every step taken to restore service in chronological order</li>
                <li>Include who performed each action and at what time</li>
                <li>Note any temporary workarounds or mitigations applied</li>
                <li>Capture rollback actions if a deployment was involved</li>
                <li>Record the time service was fully restored (TTR)</li>
              </ul>
            </div>
          </McTooltip>
          <span className="sre-section-header-badge" style={{ flex: 1 }}>
            Manual entry required
          </span>
          {!props.postmortemIsIncompleteState && (
            <button className="sre-section-header-action" onClick={() => handleRecovModal()}>
              <Icon name="pencil" style={{ fontSize: "12px" }} />
              Edit
            </button>
          )}
        </div>

        {/* Body */}
        <div
          className={`sre-section-body${!props.postmortemIsIncompleteState ? " sre-section-body--editable" : ""}`}
          onClick={!props.postmortemIsIncompleteState ? () => handleRecovModal() : undefined}
        >
          <IsLocked field="recovery" lockedFields={props.lockedFields} graphData={graphData} />
          <div style={{
            fontSize: "14px", lineHeight: 1.7,
            color: "var(--mds_brand_appearance_default_default_text-color, #141414)",
            wordBreak: "break-word",
            ...(Array.isArray(props.lockedFields) && props.lockedFields.find(f => f.fieldName === "recovery" && f.lockedBy !== graphData?.username)
              ? { border: "1px solid red", padding: "10px", borderRadius: "5px" }
              : {}),
          }}>
            {props.RecoveryState.recovery ? (
              <div dangerouslySetInnerHTML={{ __html: props.RecoveryState.recovery.replace(/\n/g, "<br/>") }} />
            ) : (
              <span style={{ color: "var(--mds_brand_appearance_default_default_text-color-secondary, #999)", fontStyle: "italic" }}>
                Please provide a description of how the service was restored, consider all the steps taken, actions performed
              </span>
            )}
          </div>
        </div>
      </div>

      <RecovModal
        handleRecovModal={handleRecovModal}
        recovModal={recovModal}
        recovery={recovery}
        setRecovery={handleRecoveryChange}
        onSave={onSave}
        savingRef={savingRef}
        lockedFields={props.lockedFields}
      />
    </>
  );
}

export default Recovery;
